import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import CoverCreator from "./pages/CoverCreator";
import Account from "./pages/Account";
import AdminCodes from "./pages/AdminCodes";
import SharePreview from "./pages/SharePreview";
import FrontMatterGenerator from "./pages/FrontMatterGenerator";
import BookOverview from "./pages/BookOverview";
import Books from "./pages/Books";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login mode="login" />} />
          <Route path="/signup" element={<Login mode="signup" />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cover/new"
            element={
              <ProtectedRoute>
                <CoverCreator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cover/:id"
            element={
              <ProtectedRoute>
                <CoverCreator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/codes"
            element={
              <ProtectedRoute>
                <AdminCodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/frontmatter"
            element={
              <ProtectedRoute>
                <FrontMatterGenerator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/frontmatter/:id"
            element={
              <ProtectedRoute>
                <FrontMatterGenerator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/books"
            element={
              <ProtectedRoute>
                <Books />
              </ProtectedRoute>
            }
          />
          <Route
            path="/book/:fmId"
            element={
              <ProtectedRoute>
                <BookOverview />
              </ProtectedRoute>
            }
          />
          <Route path="/share/cover/:token" element={<SharePreview />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
